export const exportCSV = (rows, filename) => {
  if (!rows || !rows.length) return;
  const flat = rows.map((r) => {
    const o = {};
    Object.entries(r).forEach(([k, v]) => {
      if (v !== null && typeof v === "object") Object.entries(v).forEach(([k2, v2]) => { o[`${k}_${k2}`] = v2; });
      else o[k] = v;
    });
    return o;
  });
  const cols = [...new Set(flat.flatMap((r) => Object.keys(r)))];
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [cols.join(","), ...flat.map((r) => cols.map((c) => esc(r[c])).join(","))].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const exportChartPNG = (testId, filename) => {
  const container = document.querySelector(`[data-testid="${testId}"]`);
  const svg = container && container.querySelector("svg");
  if (!svg) return;
  const rect = svg.getBoundingClientRect();
  const data = new XMLSerializer().serializeToString(svg);
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = rect.width * 2;
    canvas.height = rect.height * 2;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = document.documentElement.classList.contains("light") ? "#ffffff" : "#1E293B";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.scale(2, 2);
    ctx.drawImage(img, 0, 0, rect.width, rect.height);
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${filename}.png`;
    a.click();
  };
  img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(data)));
};
